import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: '',
    currentSummary: {},
    estimatedSummary: {},
    regions: {},
    products: {},
    months: [],
    weeks: [],
    dates: [],
    detail: {
        status: '',
        data: {}
    },
    hasInvoice: false,
    downloadLoading: {
        simpleExcel: false,
        detailCSV: false,
        invoicePDF: false
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
